module.exports = __webpack_public_path__ + "134d3fe4281a8e44be76c15900b60ba1.jpg";